import { boot } from "quasar/wrappers";
import VueAwesomeSwiper from "vue-awesome-swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css";

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(({ app }) => {
  app.use(VueAwesomeSwiper);
  app.component(Swiper);
  app.component(SwiperSlide);
});
